import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Spin } from "antd";
import Error from "@vds/icons/error";
import Battery from "@vds/icons/battery";
import Temperature from "@vds/icons/temperature";
import Location from "@vds/icons/location";
import RightCaret from "@vds/icons/right-caret";
import "./Shipment.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchAlertsContentRequest } from "../../../store/actions/shipment";
import dayjs from "dayjs";

const { Text } = Typography;

const ShipmentPopup = ({ setActiveTab, currentIndx}) => {
  const dispatch = useDispatch();
    const pathPoints = useSelector(state => state.shipment.shipmentTrackData);
  const alertCounts = useSelector((state) => state.alertsShipment.alertCounts);
  const shipmentData = useSelector(
    (state) => state.shipment.data.alertsContent.shipmentData
  );
  const deviceFields = useSelector(
    (state) => state.shipment.data.alertsContent.shipmentData?.fields
  );
  const isLoading = useSelector(
    (state) => state.shipment.data.alertsContent.isLoading
  );
  const latlongVal = useSelector((state) => state.shipment.ui.location);

  // useEffect(() => {
  //   if (!shipmentData && !isLoading) {
  //     dispatch(fetchAlertsContentRequest({}));
  //   }
  // }, [dispatch, shipmentData, isLoading]);

  let batteryPercentage = "N/A";
  if(!isNaN(deviceFields?.battery) && deviceFields?.battery !== 0){
    batteryPercentage = `${Math.round((deviceFields.battery + Number.EPSILON) * 10) / 10}%`;
  }else if(deviceFields?.battery == 0){
    batteryPercentage = "0%";
  }

  let temperatureValue = "N/A";
  if (!isNaN(deviceFields?.temperature) && deviceFields?.temperature !== 0) {
    temperatureValue = `${Math.round((((deviceFields.temperature * 9) / 5 + 32) + Number.EPSILON) * 10) / 10} F`;
  } else if (deviceFields?.temperature == 0) {
    temperatureValue = "0 F";
  }

  const originLocation= shipmentData?.deviceprofile?.locations?.find(
    (loc) => loc.locationtype === "Origin"
  )
  const metrics = [
    {
      title: "Alerts",
      value: alertCounts?.new || 0,
      icon: <Error size="XLarge" />,
      linkText: "More",
      tabDetails:"dashboard",
      span: 5,
    },
    {
      title: "Battery",
      value: currentIndx==0?batteryPercentage:`${latlongVal?.battery}%`,
      icon: <Battery size="XLarge" />,
      linkText: "Data",
      tabDetails:"Shipment Data",
      span: 5,
    },
    {
      title: "Temperature",
      value: currentIndx==0?temperatureValue:`${latlongVal?.temperature} F`,
      icon: <Temperature size="XLarge" />,
      linkText: "Data",
      tabDetails:"Shipment Data",
      span: 5,
    },
    {
      title: "Location",
      locType: currentIndx === 0 ? `${shipmentData?.currentlocation?.type || "Unknown"}` : `${latlongVal?.type || "Unknown"}`,
      value: currentIndx === 0 ? (
        <div style={{textWrap:'wrap'}}>
          <div class='location-metric-div'>
            {shipmentData?.currentlocation ? (
              `${shipmentData?.currentlocation?.lat},${shipmentData?.currentlocation?.long}`
            ) : originLocation !== "" ? (
              `${originLocation?.latitude},${originLocation?.longitude}`
            ) : (
              "N/A"
            )}
            <Location size="medium" className='metric-icon-loc'/>
          </div>
          <div class='location-metric-div-address'>
            {shipmentData?.currentaddress && shipmentData?.currentaddress !== "N/A" 
            ? shipmentData?.currentaddress 
            : originLocation?.address !== "" 
              ? originLocation?.address 
              : ""}
          </div>
        </div>
      ) : (
        <div style={{textWrap:'wrap'}}>
          <div class='location-metric-div'>
            {`${latlongVal?.coordinates[1]},${latlongVal?.coordinates[0]}`}
            <Location size="medium" className='metric-icon-loc' />
          </div>
          {latlongVal?.locationdetails}
        </div>
      ),
      icon: <Location size="small" />,
      span: 8,
    },
  ];
  return (
    <div className="shipment-container">
      <Card className="shipment-card">
        <div style={{ marginLeft: "20px", marginTop: "20px", fontFamily: "VerizonNHGDS" }}>
          Last Updated : {
            pathPoints ? pathPoints.length > 0 ? dayjs(pathPoints[pathPoints.length - 1]?.timestamp).format("DD MMM YYYY HH:mm:ss")
              : dayjs(shipmentData?.updatedat).format("DD MMM YYYY HH:mm:ss")
              : ""
          }
        </div>
        <Row>
          {metrics.map((metric, index) => (
            <Col key={metric.title} span={metric.span}>
              <div className="metric-container">
                <Text className="metric-title">{metric?.title ==="Location"?`${metric.title}(${metric?.locType})`:metric.title}</Text>
                <div className="metric-content">
                  <div className="metric-value-container">
                    <div className="metric-indicator" />
                    <Spin spinning={isLoading}>
                      {metric?.title ==="Location"?<Text className="metric-value-loc">{metric.value}</Text>:<Text className="metric-value">{metric.value}</Text>} </Spin>              
                  </div>
                  <div className="metric-actions">
                   { metric?.title !=="Location"?<div className="metric-icon">{metric.icon}</div>:''}
                    {metric.linkText && (
                      <div className="metric-link"
                        onClick={() => setActiveTab(metric?.tabDetails)}
                        style={{ cursor: "pointer" }}
                      >
                        <Text className="metric-link-text">
                          {metric.linkText}
                        </Text>
                        <RightCaret size="small" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default ShipmentPopup;
